import React from 'react';

import { NavbarItem } from '@vlabs/monokit/shared/ui/navbar-panel';
import type { NavbarItemProps } from '@vlabs/uikit/components/navbar/navbar-item/NavbarItem';
import type { NavLink } from 'react-router-dom';

import { useAccessiblePages } from '@vlabs/permissions';

interface NavbarItemWithPermissionsProps extends NavbarItemProps<typeof NavLink> {
  page?: string | string[];
  canMethod?: 'oneof' | 'allof';
}

function NavbarItemWithPermissions({
  page,
  canMethod = 'oneof',
  ...props
}: NavbarItemWithPermissionsProps): React.JSX.Element | null {
  const accessiblePages = useAccessiblePages();

  if (page) {
    const rules = Array.isArray(page) ? page : [page];
    const hasWildcard = accessiblePages.includes('*');
    const hasAccess = hasWildcard || (canMethod === 'allof'
      ? rules.every((r) => accessiblePages.includes(r))
      : rules.some((r) => accessiblePages.includes(r)));
    if (!hasAccess) return null;
  }

  return (
    <NavbarItem {...props} />
  );
}

export { NavbarItemWithPermissions };
